import React from 'react';
import { Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import './ModalGeneral.css'; // Asegúrate de que los estilos estén correctos

function ModalGeneral({
  warning = false,
  success = false,
  header,
  title,
  subtitle,
  description,
  children,
  isShow,
  handleShow,
  onHide,
  confirm,
  cancel,
  onClickConfirm,
  onClickCancel = () => {},
  size = 'md',
  backdrop = 'static',
  keyboard = false,
  className = '',
  colorIcon = 'black',
  colorTitle = 'black',
  colorSubtitle = 'black',
  colorDescription = 'black',
  boldDescription = false,
  bgHeader = 'white',
  headerClassName = '',
  ...props
}) {
  return (
    <Modal
      className={`${className} modal-general-custom`}
      show={isShow}
      onHide={onHide ? onHide : () => {
        handleShow(false);
        onClickCancel();
      }}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      size={size}
      backdrop={backdrop}
      keyboard={keyboard}
    >
      <Modal.Header
        closeButton
        className={headerClassName ? `${headerClassName} modal-general-custom-header` : 'modal-general-custom-header'}
        style={{
          padding: '1rem 2rem 1rem',
          backgroundColor: bgHeader,
          color: colorIcon,
          border: 'none'
        }}
      >
        <div className="modal-header-center-flex">
          {success || warning ? (
            <FontAwesomeIcon
              className="mb-2"
              icon={success ? faCircleCheck : faCircleExclamation}
              style={{ fontSize: '35px' }}
            />
          ) : null}
          <h3
            className="title-modal-st my-0"
            style={{ fontSize: '24px', fontWeight: '700', color: colorTitle }}
          >
            {title}
          </h3>
          {subtitle && (
            <label className="description-modal-st my-0"
              style={{ fontSize: '16px', fontWeight: '400', color: '#999', margin: 0 }}>
             {subtitle}
            </label>
          )}
        </div>
      </Modal.Header>
      
      <Modal.Body className={children ? 'p-1' : 'text-center'}>
        {description && (
          <p
            style={{
              fontSize: '16px',
              fontWeight: boldDescription ? '700' : 'normal',
              color: colorDescription
            }}
          >
            {description}
          </p>
        )}
        
        {children}
      </Modal.Body>

      {(confirm || cancel) && (
        <Modal.Footer
          className="d-flex justify-content-center align-items-center gap-3"
          style={{
            backgroundColor: 'rgba(255, 233, 0, 0.05)',
            borderTop: '1px solid #dee2e6'
          }}
        >
          {cancel && (
            <button
              className="btn btn-outline-black"
              style={{ width: props.widthBtns ?? '48%' }}
              onClick={onClickCancel}
            >
              {cancel}
            </button>
          )}
          {confirm && (
            <button
              className="btn btn-block yellow"
              style={{ width: props.widthBtns ?? '48%', border: 'none' }}
              onClick={onClickConfirm}
            >
              {confirm}
            </button>
          )}
        </Modal.Footer>
      )}
    </Modal>
  );
}

export default ModalGeneral;